module.exports = __webpack_public_path__ + "app-static/img/kksb.e7d19b14.png";